import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=45c2c38d&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=ts"
export * from "./Instructions.vue?vue&type=script&lang=ts"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=45c2c38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2c38d",
  null
  
)

export default component.exports